import React from 'react';
import './Navbar.css';

const Navbar = ({ onTodayTicketClick }) => {
  return (
    <>
      <div className="nav-container">
        <h1>TicketChecker.in</h1>
        <div className="nav-items">
          <a href="/" onClick={(e) => { e.preventDefault(); onTodayTicketClick(); }}>
            Today Booking
          </a>
          <a href="/">Contact US</a>
        </div>
      </div>
    </>
  );
};

export default Navbar;
